import { createRoot } from "react-dom/client";
import App from "./app.jsx";
import "./scss/style.scss";

const rootEl = document.getElementById("root");
createRoot(rootEl).render(<App />);

